import { createSlice } from '@reduxjs/toolkit';

/** Aliases a menu can start without knowing the page: the page's own tour, or the welcome. */
export const PAGE_TOUR = '@page';
export const WELCOME_TOUR = '@welcome';

/**
 * The guided tour that is running, if any. Progress (which tours were seen) lives in
 * localStorage per user, see `@/lib/tour-progress`; this slice only drives the overlay so the
 * Help menu, the command palette and pages can all start a tour.
 */
const tourSlice = createSlice({
  name: 'tour',
  initialState: {
    activeTourId: null,
    stepIndex: 0,
  },
  reducers: {
    startTour: (state, action) => {
      state.activeTourId = action.payload;
      state.stepIndex = 0;
    },
    setTourStep: (state, action) => {
      state.stepIndex = action.payload;
    },
    endTour: state => {
      state.activeTourId = null;
      state.stepIndex = 0;
    },
  },
});

export const { startTour, setTourStep, endTour } = tourSlice.actions;
export default tourSlice.reducer;
